import { getMiniCartClient } from '@components/MiniCart/miniCartClient';
import { createCommerceAxiosClient } from '@lib/http/commerceAxiosClient';
import type { AxiosInstance } from 'axios';

/**
 * The PDP's commerce-core client. With MULTI_CART on, commerce-core's one
 * global client is set by whichever of the PDP's provider and the header
 * mini-cart's rendered last: both hand it the mini-cart's client and its
 * timeouts, so the header's cart read on a PDP no longer hangs on a client
 * without one (CPS-7696). Off, the PDP keeps its own, as before.
 */
export const createCommerceCartClient = (
  isMultiCartEnabled: boolean
): AxiosInstance =>
  isMultiCartEnabled
    ? getMiniCartClient()
    : createCommerceAxiosClient('usg-direct');
